import { atom } from "jotai";

export const stepsDrawerAtom = atom(false);

export const pictureUploadingAtom = atom(false);
export const pictureCacheTimeAtom = atom(Date.now());
